import { TextField as MuiTextField } from "@mui/material";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const TextFieldWithStyles = styled(MuiTextField)`
  & .MuiOutlinedInput-root {
    padding: 0px 0.625rem;

    color: ${(props) => props.theme.palette.secondary.contrastText};
    background-color: ${(props) => props.theme.palette.background.paper};

    input::placeholder {
      color: ${(props) => props.theme.palette.secondary.contrastText};
      opacity: 0.5;
    }

    & fieldset {
      border-color: ${(props) =>
        props.theme.palette.background.paper} !important;
      border-width: 1px !important;
    }
  }
`;

const Label = styled(Typography)`
  margin-left: 1.3rem;
  font-size: 0.625rem;
`;

const TextField = ({ label, ...props }) => {
  return (
    <>
      {label && (
        <Label variant="caption" display="block" gutterBottom>
          {label || "Label"}
        </Label>
      )}
      <TextFieldWithStyles
        fullWidth
        InputLabelProps={{ shrink: false }}
        variant="outlined"
        {...props}
      />
    </>
  );
};

export default TextField;
